import { render, staticRenderFns } from "./categoryPage.vue?vue&type=template&id=4f759734&"
import script from "./categoryPage.vue?vue&type=script&lang=js&"
export * from "./categoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports